<script setup>
import PageCheckoutSignup from "@/features/subscribe/PageCheckoutSignup.vue";
import UserReviews from "@/features/subscribe/UserReviews.vue";
import PageCheckoutHeader from "@/features/subscribe/PageCheckoutHeader.vue";
import { useWindowSize } from "@vueuse/core";
import { computed, onMounted } from "vue";
import { posthogCapture } from "@/scripts/posthog.js";

defineProps({
  headlessUser: {
    type: [Object, null],
    default: null,
  },
  error: {
    type: String,
    default: null,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["setUser"]);

const { width } = useWindowSize();
const isDesktop = computed(() => width.value > 700);

onMounted(() => posthogCapture("user_viewed_checkout_page"));
const onSubscribed = (plan) => posthogCapture("user_subscribed", plan);
</script>

<template>
  <div class="page-checkout">
    <PageCheckoutHeader>
      <UserReviews v-if="isDesktop" />
    </PageCheckoutHeader>
    <PageCheckoutSignup
      :headless-user="headlessUser"
      :signup-error="error"
      :is-signing-up="isLoading"
      @set-user="$emit('setUser', $event)"
      @subscribed="onSubscribed"
    />
  </div>
</template>

<style scoped lang="scss">
.page-checkout {
  padding: 0;
}
</style>
